import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFamilyContext } from '../../contexts/FamilyContext';
import pwaAuthFix from '../../utils/pwaAuthFix';

export default function Welcome() {
  const navigate = useNavigate();
  const { currentUser, family, loading } = useFamilyContext();

  useEffect(() => {
    // Don't redirect while still loading
    if (loading) return;

    console.log('🏠 Welcome component - determining redirect:', {
      currentUser: currentUser?.id,
      isParent: currentUser?.isParent,
      hasFamily: !!family,
      isPWA: pwaAuthFix.isPWAMode()
    });

    // Skip delay for PWA mode since splash screen already shows loading
    const delay = pwaAuthFix.isPWAMode() ? 0 : 1000;

    // Add delay only for non-PWA mode
    const timer = setTimeout(() => {
      if (currentUser?.isParent || currentUser?.originalParent) {
        console.log('🚀 Redirecting parent to parent-dashboard');
        navigate('/parent-dashboard', { replace: true });
      } else {
        console.log('🚀 Redirecting to dashboard');
        navigate('/dashboard', { replace: true });
      }
    }, delay);

    return () => clearTimeout(timer);
  }, [navigate, currentUser, family, loading]);

  // In PWA mode, don't show another loading screen since splash already handles it
  if (pwaAuthFix.isPWAMode()) {
    return null;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 to-stone-100">
      <div className="text-center max-w-md mx-auto px-6">
        {/* Logo/Brand */}
        <div className="mb-8">
          <div className="w-20 h-20 bg-stone-950 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </div>
          <h1 className="text-3xl font-bold text-stone-900 mb-2">Paper Sedge</h1>
          <p className="text-stone-600">Your complete family planning app</p>
        </div>

        {/* Loading indicator */}
        <div className="mb-6">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-stone-600">Taking you to your dashboard...</p>
        </div>

        {/* Fallback link */}
        <p className="text-sm text-stone-500">
          Taking too long?{' '}
          <button 
            onClick={() => navigate('/dashboard')}
            className="text-primary-600 hover:text-primary-700 underline"
          >
            Click here to continue
          </button>
        </p>
      </div>
    </div>
  );
}